import { render, staticRenderFns } from "./NF.vue?vue&type=template&id=b5ed43a0&scoped=true&lang=pug&"
import script from "./NF.vue?vue&type=script&lang=js&"
export * from "./NF.vue?vue&type=script&lang=js&"
import style0 from "./NF.vue?vue&type=style&index=0&id=b5ed43a0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ed43a0",
  null
  
)

export default component.exports